import { Mail, Monitor, Phone } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Anchor, Heading, Text, XStack, YStack } from "tamagui";

import { IconContainer } from "../../components/IconContainer";

export const Help = () => {
  const { t } = useTranslation();

  const emailSupport = "contact@homeserviceco.com";
  const sensorSupport = "(913) 123-6322";
  const softwareSupport = "(331) 631-6562";

  return (
    <YStack gap="$4" width="100%">
      <YStack gap="$2">
        <Text fontSize="$5.5">{t("sidebar.settings.settings")}</Text>
        <Heading fontSize="$8">{t("sidebar.settings.help")}</Heading>
      </YStack>
      <XStack width="100%" gap="$3.5">
        <YStack
          minWidth={0}
          flex={1}
          gap="$3.5"
          backgroundColor="$transparentBorder"
          padding="$3.5"
          borderRadius="$4"
          width="100%"
          justifyContent="space-between"
        >
          <IconContainer>
            <Mail size={20} />
          </IconContainer>
          <Text fontSize="$3.5" color="$white12" paddingBottom="$4">
            {t("help.generalEmailSupport")}
          </Text>
          <Anchor
            href={`mailto:${emailSupport}`}
            fontWeight="700"
            fontSize="$4"
            target="_blank"
            rel="noopener noreferrer"
          >
            {emailSupport}
          </Anchor>
        </YStack>
        <YStack
          flex={1}
          minWidth={0}
          gap="$3.5"
          backgroundColor="$transparentBorder"
          padding="$3.5"
          borderRadius="$4"
          width="100%"
          justifyContent="space-between"
        >
          <IconContainer>
            <Phone size={20} />
          </IconContainer>
          <Text fontSize="$3.5" color="$white12" paddingBottom="$4">
            {t("help.setupSupport")}
          </Text>
          <Anchor href={`tel:${sensorSupport}`} fontSize="$4" fontWeight="700">
            {sensorSupport}
          </Anchor>
        </YStack>
        <YStack
          flex={1}
          gap="$3.5"
          minWidth={0}
          backgroundColor="$transparentBorder"
          padding="$3.5"
          borderRadius="$4"
          width="100%"
          justifyContent="space-between"
        >
          <IconContainer>
            <Monitor size={20} />
          </IconContainer>
          <Text
            fontSize="$3.5"
            color="$white12"
            flexWrap="wrap"
            paddingBottom="$4"
          >
            {t("help.appSupport")}
          </Text>
          <Anchor
            href={`tel:${softwareSupport}`}
            fontSize="$4"
            fontWeight="700"
          >
            {softwareSupport}
          </Anchor>
        </YStack>
      </XStack>
    </YStack>
  );
};
export default Help;
